import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

import Header from "../components/Header";
import Footer from "../components/Footer";

import YoutubeIcon from "../assets/vectors/youtube.svg";
import InstagramIcon from "../assets/vectors/instagram-logo.svg";
import TwitterIcon from "../assets/vectors/twitter-logo.svg";
import EmailIcon from "../assets/vectors/email.svg";

const Container = styled.div`
  display: flex;
  min-height: calc(100vh);
  height: 100vh;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin: 0;
  }
`;
const Wrapper = styled.div`
  width: 1200px;
  margin: 96px auto;
  height: 100%;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
  & > div {
    padding: 60px 10rem 0;
    width: calc(100% - 20rem);
    @media screen and (max-width: 425px) {
      padding: 40px 3rem 0;
      width: calc(100% - 6rem);
    }
  }
`;
const Text = styled.p`
  color: #315c89;
  font-weight: 400;
  font-size: 20px;
  margin-block-start: 0.2em;
  margin-block-end: 0.2em;
`;
/* const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > img {
    margin-right: 20px;
  }
`; */
const Link = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  width: max-content;
  margin: 20px 0;
  & > img {
    margin-right: 20px;
  }
`;
function Contact() {
  const [pageData, setPageData] = useState({
    title: null,
    content: null,
    link: null,
    cover_image: null,
  });
  /*  useEffect(() => {
    axios
      .get(`${SERVER_URL}/static-pages?slug=iletisim`)
      .then((response) => {
        if (response.status !== 200) return;
        setPageData(response.data[0]);
      })
      .catch((err) => console.log(err));
  }, []); */
  return (
    <>
      <Container>
        <Header />
        <Wrapper>
          <div>
            {/* {pageData.content && (
              <Text
                dangerouslySetInnerHTML={{ __html: marked(pageData.content) }}
              />
            )} */}
            <Text>
              Kanal İstanbul ile ilgili merak ettiklerinizi sormak için bizimle
              iletişime geçebilirsiniz.
            </Text>{" "}
            <Link href="mailto:iletisim.sgb@uab.gov.tr" target="_blank">
              <img src={EmailIcon} alt="" width="25" />
              <Text>iletisim.sgb@uab.gov.tr</Text>
            </Link>
            <div style={{ marginTop: "70px" }}>
              <Link href="https://twitter.com/KANAListanbul/" target="_blank">
                <img src={TwitterIcon} alt="" width="25" />
                <Text>KANAListanbul</Text>
              </Link>
              <Link
                href="https://www.youtube.com/channel/UCl4Q9d6eXbuQl44PKjJEXIg"
                target="_blank"
              >
                {" "}
                <img src={YoutubeIcon} alt="" width="25" />
                <Text>Kanal Istanbul</Text>
              </Link>
              <Link
                href="https://www.instagram.com/kanalistanbul/"
                target="_blank"
              >
                <img src={InstagramIcon} alt="" width="25" />
                <Text>kanalistanbul</Text>
              </Link>
            </div>
          </div>

          {/*  <Email>
            <a href="mailto:sgb@uab.gov.tr">sgb@uab.gov.tr</a>
          </Email> */}
        </Wrapper>
        <Footer />
      </Container>
    </>
  );
}
export default Contact;
